import {LoadingContext} from "../store/loadingMessageStore";
import {useViewerStore} from "../store/store";
import {
    LoadModelJson,
    LoadModelXML
} from "../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Loader";
import {logger} from "../services/loggingService";
import type { NavigateFunction } from "react-router-dom";
import { reportSiteLoadErrorForDashboard } from "../helpers/reportSiteLoadErrorForDashboard";

/** `navigate` kept for callers; load uses store + loader only. */
export const getSite = async (_navigate: NavigateFunction) => {
    const loadingContext = new LoadingContext();
    loadingContext.setMessage({ message: 'Fetching Site Data...' });
    const sceneViewer = useViewerStore.getState().sceneViewer;
    const siteDesigns = useViewerStore.getState().siteDesigns;

    useViewerStore.setState({
        designID: 0,
        siteBuildingData: [],
        isSiteReCentered: false,
        selectedDesignIndex: -1,
        selectedLossesVendor: 'oneDRAW',
    });

    try {
        if (siteDesigns.aurora != null) {
            loadingContext.setToBackground(true);
            loadingContext.setMessage({ title: '', message: 'Drawing Site...' });
            await LoadModelJson(sceneViewer, siteDesigns.aurora);
            useViewerStore.setState({selectedSiteDesign : 'aurora'});
        } else if (siteDesigns.eagleView != null) {
            loadingContext.setToBackground(true);
            loadingContext.setMessage({ title: '', message: 'Drawing Site...' });
            await LoadModelXML(sceneViewer, siteDesigns.eagleView);
            useViewerStore.setState({selectedSiteDesign : 'eagleView'});
        } else {
            throw new Error(
                'No Aurora/EagleView design data was found for this site. Try reloading the site, or verify in Salesforce that a design has been loaded before continuing.',
            );
        }
    } catch (e) {
        logger.error(e);
        const errMessage =
            e instanceof Error
                ? e.message
                : typeof e === 'string'
                  ? e
                  : 'Unknown error';
        const isNoDesignData =
            errMessage.toLowerCase().includes('no aurora/eagleview design data') ||
            errMessage.toLowerCase().includes('no design data');
        const displayMessage = isNoDesignData
            ? errMessage
            : 'Something went wrong while loading the site. Please try again later or refresh the browser.\n'
              + `Error: ${errMessage}`;
        reportSiteLoadErrorForDashboard(displayMessage);
    } finally {
        loadingContext.dispose();
    }
};
